export default [
  {
    name: 'Patient Chat',
    path: '/chat/:url',
    component: () => import(/* webpackChunkName: "patient" */ '@/views/messaging/PatientSecureChatView.vue')
  }
]
